import { render } from "./VolumeStoragePoolSelectForm.vue?vue&type=template&id=5f01a452&scoped=true"
import script from "./VolumeStoragePoolSelectForm.vue?vue&type=script&lang=js"
export * from "./VolumeStoragePoolSelectForm.vue?vue&type=script&lang=js"

import "./VolumeStoragePoolSelectForm.vue?vue&type=style&index=0&id=5f01a452&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.3.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f01a452"]])

export default __exports__